export const PRESENTATION_CODE = "AMPLI012";

const startsWithPresentationCode = (value) => (
  typeof value === "string"
  && value.trim().toUpperCase().startsWith(PRESENTATION_CODE)
);

export const isPresentationProject = (project) => !!project && (
  project.read_only === true
  || project.presentation_mode === true
  || startsWithPresentationCode(project.presentation_code)
  || startsWithPresentationCode(project.building_wbs)
  || startsWithPresentationCode(project.wbs_code_id)
  || (Array.isArray(project.wbs_code_ids) && project.wbs_code_ids.some(startsWithPresentationCode))
);

export const presentationReadOnlyResult = () => ({
  code: 403,
  errorCode: "presentation_read_only",
  message: "Obra de apresentação: edição e atualização desabilitadas.",
});

export const canRefreshPrevision = (project) => !!project && (
  project.hasPrevision === true
  && project.previsionMode === "live"
  && project.canRefreshPrevision === true
  && !isPresentationProject(project)
);

export const runProjectMutation = async (project, mutation) => {
  if (isPresentationProject(project)) return presentationReadOnlyResult();
  return mutation();
};
